export const COMPLETE_PROFILE_DRAFT_KEY = 'completeProfileDraft';

export function formatLocalDateString(date) {
  if (!date || Number.isNaN(date.getTime())) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function parseLocalDateString(dateStr) {
  if (!dateStr) return null;
  const [year, month, day] = dateStr.split('T')[0].split('-').map(Number);
  if (!year || !month || !day) return null;
  const parsed = new Date(year, month - 1, day);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function formatDisplayDate(date) {
  if (!date || Number.isNaN(date.getTime())) return null;
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day} - ${month} - ${year}`;
}

export function saveCompleteProfileDraft(formState) {
  const draft = {
    selectedDate: formatLocalDateString(formState.selectedDate),
    selectedGender: formState.selectedGender,
    selectedNation: formState.selectedNation,
    selectedState: formState.selectedState,
    selectedCity: formState.selectedCity,
    selectedEducation: formState.selectedEducation,
    selectedCivilState: formState.selectedCivilState,
    selectedRegion: formState.selectedRegion,
    selectedProvincia: formState.selectedProvincia,
    selectedComune: formState.selectedComune,
    showInfo: formState.showInfo,
  };
  sessionStorage.setItem(COMPLETE_PROFILE_DRAFT_KEY, JSON.stringify(draft));
}

export function loadCompleteProfileDraft() {
  try {
    const raw = sessionStorage.getItem(COMPLETE_PROFILE_DRAFT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearCompleteProfileDraft() {
  sessionStorage.removeItem(COMPLETE_PROFILE_DRAFT_KEY);
}
